"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZOOM_SLIDER_MARGIN = exports.DEFAULT_ZOOM_SLIDER_SIZE = void 0;
/** Margin in the opposite direction of the axis, i.e., horizontal if the axis is vertical and vice versa. */
const ZOOM_SLIDER_MARGIN = exports.ZOOM_SLIDER_MARGIN = 4;

/** Size reserved for the zoom slider. The actual size of the slider might be smaller. */
const DEFAULT_ZOOM_SLIDER_SIZE = exports.DEFAULT_ZOOM_SLIDER_SIZE = 20 + 2 * ZOOM_SLIDER_MARGIN;